<!--新建模板页面  -->
<template>
  <div class="ProgramTemplate">
    <!-- 左边列表模块 -->
    <div class="ProgramTemplateLeft">
      <template-page-left></template-page-left>
    </div>
    <!-- 右边创建编辑模块 -->
    <div class="ProgramTemplateRight">
      <template-page-right></template-page-right>
    </div>
  </div>
</template>

<script>
import TemplatePageLeft from './TemplatePageLeft'
import TemplatePageRight from './TemplatePageRight'
export default {
  data () {
    return {}
  },
  components: {
    TemplatePageLeft,
    TemplatePageRight
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="less">
.ProgramTemplate {
  display: flex;
  height: 100%;
  .ProgramTemplateLeft {
    width: 300px;
    height: 100%;
    background: #444444;
  }
  .ProgramTemplateRight {
    width: calc(100% - 300px);
    height: 100%;
    background: #252525;
  }
}
</style>
